import { apiGet, apiPost } from "./client";

/**
 * NOTIFICATIONS — the minimal version.
 *
 * Deliberately small: list them, clear them. No channels, no email, no
 * digests, no preferences. What it has to show is the SHAPE — something
 * happens in one tier and the tier that needs to know finds out without a
 * person telling them.
 *
 * Scoped to the COMPANY on the server, not the user: a scheme signed off while
 * its author is on leave must still reach whoever is covering.
 */

export interface Notification {
  id: string;
  type: string;
  msg: string;
  /** Where the bell takes you — a route, never a page. */
  nav: { to?: string } | null;
  read: boolean;
  created_at: string;
}

export function fetchNotifications(): Promise<{ notifications: Notification[]; unread: number }> {
  return apiGet<{ notifications: Notification[]; unread: number }>("/api/notifications");
}

export function markNotificationsRead(): Promise<{ cleared: number }> {
  return apiPost<{ cleared: number }>("/api/notifications/read");
}
